export const teacherColumn = [
  {
    title: '学生姓名',
    dataIndex: 'studentName',
    colKey: 'studentName',
    align: 'left',
    width: '120px',
  },
  {
    title: '参与展示率',
    dataIndex: 'studentRate',
    colKey: 'studentRate',
    headerAlign: 'center',
    align: 'right',
    width: '120px',
  },
  {
    title: '课堂成果提交数',
    dataIndex: 'courseWorkNum',
    colKey: 'courseWorkNum',
    headerAlign: 'center',
    align: 'right',
    width: '160px',
  },
  {
    title: '课堂成果累计获赞数',
    dataIndex: 'courseWorkPraisedNum',
    colKey: 'courseWorkPraisedNum',
    headerAlign: 'center',
    align: 'right',
    width: '200px',
  },
  {
    title: '检测答题数',
    dataIndex: 'detectionNum',
    colKey: 'detectionNum',
    headerAlign: 'center',
    align: 'right',
    width: '120px',
  },
  {
    title: '检测正确率',
    dataIndex: 'detectionRate',
    colKey: 'detectionRate',
    headerAlign: 'center',
    align: 'right',
    width: '120px',
  },
  {
    title: '抢答成功次数',
    dataIndex: 'answerNum',
    colKey: 'answerNum',
    headerAlign: 'center',
    align: 'right',
    width: '160px',
  },
  {
    title: '参与演示次数',
    dataIndex: 'presentationNum',
    colKey: 'presentationNum',
    headerAlign: 'center',
    align: 'right',
    width: '160px',
  },
  {
    title: '推送资源个数',
    dataIndex: 'resourcePushNum',
    colKey: 'resourcePushNum',
    headerAlign: 'center',
    align: 'right',
    width: '160px',
  },
  {
    title: '推送资源个数',
    dataIndex: 'resourceViewNum',
    colKey: 'resourceViewNum',
    headerAlign: 'center',
    align: 'right',
    width: '160px',
  },
  {
    title: '推送资源查看数',
    dataIndex: 'resourceViewNum',
    colKey: 'resourceViewNum',
    headerAlign: 'center',
    align: 'right',
    width: '160px',
  },
  {
    title: '学程提交卡完成数',
    dataIndex: 'courseWorkCardNum',
    colKey: 'courseWorkCardNum',
    headerAlign: 'center',
    align: 'right',
    minWidth: '160px',
  },
]
